export default String.raw`
.card-product {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 461px;
    row-gap: 16px;
    margin: 0 auto;
    background-color: $bgColor;
    overflow: hidden;
    position: relative;
    padding: 3px;

    &__image {
        display: flex;
        width: 100%;
        height: 269px;
        justify-content: center;
        align-items: center;

        &-flags {
            width: fit-content;
            position: absolute;
            display: flex;
            flex-direction: column;
            row-gap: 2px;
            z-index: 998;
            top: 0;
            left: 0;

            .ribbon {
                width: fit-content;
            }
        }

        img {
            max-width: 100%;
            max-height: 100%;
            border-radius: 8px;
        }
    }

    &__info {
        display: flex;
        width: 100%;
        flex-direction: column;
        gap: 16px;

        a:hover {
            color: $primaryColorFont;
        }

        &-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    }

    &__name {
        height: 40px;
        color: $primaryColorFont;
        @include body-1-regular;
        text-decoration: none;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    &__prices {
        display: flex;
        gap: 8px;
        align-items: baseline;
        flex-wrap: wrap;
    }

    &__deposit-price {
        margin-top: -12px;
        @include body-2-regular;
        color: $bgColorFont;
    }

    &__price {
        &-current {
            @include body-1-semi-bold;
        }

        &-previous {
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;
            color: $bgColorFont;
        }

        &-tax {
            @include body-1-regular;
        }

        &-lowest {
            @include body-2-regular;
            color: $bgColorFont;
        }
    }

    &__buttons {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }
}
`